import styles from "./sellproductpage.module.css";
import SellerPageFilterBar from "../../components/SellerPageFilterBar";
import SellerPageHeader from "../../components/SellerPageHeader";
import ProductListBlock from "../../components/ProductListBlock";
import HomePageFooter from "../../components/HomePageFooter";
export default function SellerProductPage() {
  return (
    <div className={`container-fluid h-custom ${styles.page}`}>
      <div className={`row ${styles.header}`}>
        <SellerPageHeader />
      </div>
      <div className={`row ${styles.body}`}>
        <div className={`col-2 ${styles.navBar}`}>
          <SellerPageFilterBar />
        </div>
        <div className={`col-10 mb-5 ${styles.productlistBlock}`}>
          <ProductListBlock />
        </div>
      </div>
      <div className={`row ${styles.footer}`}>
        <HomePageFooter />
      </div>
    </div>
  );
}
